import React from "react";
import Components from "../services/Components";
import Cookies from 'js-cookie'
import axios from "axios";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'

function TabComponent({
  name,
  object,
  index,
  useVals,
  setTabs,
  active,
  setTabsImage,
  setObject2,
}) {
  const [list, setList] = React.useState();
  React.useEffect(() => {

    setList(object[name])
  }, [object]);
  const initialDnDState = {
    draggedFrom: null,
    draggedTo: null,
    isDragging: false,
    originalOrder: [],
    updatedOrder: []
  }
  const [dragAndDrop, setDragAndDrop] = React.useState(initialDnDState);
  // Not needed, just for logging purposes:

  const [sortedList, setSortedList] = React.useState()
  const onDragStart = (event) => {
    const myList = list;
    console.log(myList)
    const findIndexById = (id) => {
      return myList.findIndex(item => item.ParameterId === id);
    };
    let checkid = event.target.id;
    let structuretype = checkid.split('-');
    const searchId = structuretype[1];
    const index = findIndexById(Number(searchId));
    console.log(index)
    const initialPosition = Number(index);

    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: initialPosition,
      isDragging: true,
      originalOrder: list
    });

    event.dataTransfer.setData("text/html", '');
  }

  const onDragOver = (event) => {

    event.preventDefault();

    let newList = dragAndDrop.originalOrder;
    const draggedFrom = dragAndDrop.draggedFrom;
    const findIndexById = (id) => {
      return newList.findIndex(item => item.ParameterId === id);
    };
    let checkid = event.target.id;
    let structuretype = checkid.split('-');
    const searchId = structuretype[1];
    const draggedTo = findIndexById(Number(searchId));
    //const draggedTo = Number(event.currentTarget.dataset.position); 
    if (draggedTo != -1) {
      const itemDragged = newList[draggedFrom];
      const remainingItems = newList.filter((item, index) => index !== draggedFrom);

      newList = [
        ...remainingItems.slice(0, draggedTo),
        itemDragged,
        ...remainingItems.slice(draggedTo)
      ];


      setDragAndDrop({
        ...dragAndDrop,
        updatedOrder: newList,
        draggedTo: draggedTo
      })

    }
  }

  const onDrop = (event) => {

    setList(dragAndDrop.updatedOrder);

    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: null,
      draggedTo: null,
      isDragging: false
    });
  }


  const onDragLeave = () => {
    setDragAndDrop({
      ...dragAndDrop,
      draggedTo: null
    });

  }

  React.useEffect(() => {

    var formID = Cookies.get('FormID');
    var name = Cookies.get('username');
    let params = {
      username: name,
      Stage: "L",
      formId: formID,
      userType: "AutoSaveOrder",
      parameters: []
    };
    params.StructureTypes = [{
      StructureType: active,
      Calculations: list,
    }
    ]
    params = JSON.stringify({
      Body: params,
    });
    return axios
      .post('https://msbp54qxc1.execute-api.us-west-2.amazonaws.com/Prod/singlefamily', params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        crossorigin: true,
      })
      .then((res) => {
        // setLoading(false);
        return res.data;
      })
      .catch((e) => {
        // setLoading(false);
        alert(e.message);
      });




  }, [list])
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  function Iscollapse(e) {
    let classname = document.getElementById(e).className;
    if (classname == "fa fa-caret-down") {
      //document.getElementById(e).d="M6.628,9.864.076,3.337H13.219Z";
      document.getElementById(e).className = "fa fa-caret-right";
    }
    else {


      document.getElementById(e).className = "fa fa-caret-down";

      //document.getElementById(e).d="M6.628,9.864.076,3.337H13.219Z";
    }
  }
  function closeInfo(e) {
    console.log(e);
    SetIsDisplay("info display");
    let ID = Isinfostyle;

    let ParamID = ID.split('-')[1];
    let StructureType = ID.split('-')[0];
    let color1 = document.getElementById("color1").value;
    let color2 = document.getElementById("color2").value;
    let color3 = document.getElementById("color3").value;
    document.getElementById(e).style.display = 'none';
    if (ParamID == 85 || ParamID == 86 || ParamID == 217 || ParamID == 71) {
      document.getElementById(ID).style.background = '#f7f7f7';
    }
    else if (ParamID == 96 || ParamID == 79) {
      document.getElementById(ID).style.background = 'transparent';
    }
    else {
      if (ParamID == 198) {
        if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
          document.getElementById(StructureType + "-198").style.background = color1;
          document.getElementById(StructureType + "-201").style.background = color2;
          document.getElementById(StructureType + "-229").style.background = color3;
        }
        if (StructureType == "Condo" || StructureType == "Apartment") {
          document.getElementById(StructureType + "-198").style.background = color1;
          document.getElementById(StructureType + "-202").style.background = color2;
          document.getElementById(StructureType + "-229").style.background = color3;
        }
        if (StructureType == "Single Family") {
          document.getElementById(StructureType + "-198").style.background = color1;
          document.getElementById(StructureType + "-200").style.background = color2;
          document.getElementById(StructureType + "-229").style.background = color3;
        }
      }
      if (ParamID == 186) {
        if (StructureType == "Townhome" || StructureType == "Cottage" || StructureType == "Rowhouse") {
          document.getElementById(StructureType + "-186").style.background = color1;
          document.getElementById(StructureType + "-208").style.background = color2;
          document.getElementById(StructureType + "-224").style.background = color3;
        }
        if (StructureType == "Condo" || StructureType == "Apartment") {
          document.getElementById(StructureType + "-186").style.background = color1;
          document.getElementById(StructureType + "-209").style.background = color2;
          document.getElementById(StructureType + "-224").style.background = color3;
        }
        if (StructureType == "Single Family") {
          document.getElementById(StructureType + "-186").style.background = color1;
          document.getElementById(StructureType + "-223").style.background = color2;
          document.getElementById(StructureType + "-224").style.background = color3;
        }
      }
      if (ParamID == 187) {
        document.getElementById(StructureType + "-187").style.background = color2;
      }
      if (ParamID == 214) {
        document.getElementById(StructureType + "-214").style.background = color2;
      }
      if (ParamID == 225) {
        document.getElementById(StructureType + "-225").style.background = color2;
      }
      if (ParamID == 88) {
        document.getElementById(StructureType + "-88").style.background = color1;
        document.getElementById(StructureType + "-238").style.background = color2;
      }
      if (ParamID == 89) {
        document.getElementById(StructureType + "-89").style.background = color1;
        document.getElementById(StructureType + "-237").style.background = color2;
      }
      if (ParamID == 91) {
        document.getElementById(StructureType + "-91").style.background = color1;
        document.getElementById(StructureType + "-236").style.background = color2;
      }
      if (ParamID == 105) {
        document.getElementById(StructureType + "-105").style.background = color1;
        document.getElementById(StructureType + "-235").style.background = color2;
      }
      if (ParamID == 90) {
        document.getElementById(StructureType + "-90").style.background = color1;
        document.getElementById(StructureType + "-234").style.background = color2;
      }
      if (ParamID == 106) {
        document.getElementById(StructureType + "-106").style.background = color1;
        document.getElementById(StructureType + "-233").style.background = color2;
      }
      if (ParamID == 87) {
        document.getElementById(StructureType + "-87").style.background = color1;
        document.getElementById(StructureType + "-232").style.background = color2;
      }

      if (ParamID == 109) {
        document.getElementById(StructureType + "-109").style.background = color1;
        document.getElementById(StructureType + "-97").style.background = color2;
        document.getElementById(StructureType + "-239").style.background = color3;
      }
      if (ParamID == 115) {
        document.getElementById(StructureType + "-115").style.background = color1;
        document.getElementById(StructureType + "-104").style.background = color2;
        document.getElementById(StructureType + "-241").style.background = color3;
      }
      if (ParamID == 240) {
        document.getElementById(StructureType + "-240").style.background = color1;
        document.getElementById(StructureType + "-124").style.background = color2;
        document.getElementById(StructureType + "-242").style.background = color3;
      }
      if (ParamID == 113) {
        document.getElementById(StructureType + "-113").style.background = color1;
        document.getElementById(StructureType + "-102").style.background = color2;
        document.getElementById(StructureType + "-239").style.background = color3;
      }
      if (ParamID == 114) {
        document.getElementById(StructureType + "-114").style.background = color1;
        document.getElementById(StructureType + "-103").style.background = color2;
        document.getElementById(StructureType + "-239").style.background = color3;
      }
      if (ParamID == 112) {
        document.getElementById(StructureType + "-112").style.background = color1;
        document.getElementById(StructureType + "-100").style.background = color2;
        document.getElementById(StructureType + "-239").style.background = color3;
      }
      if (ParamID == 111) {
        document.getElementById(StructureType + "-111").style.background = color1;
        document.getElementById(StructureType + "-101").style.background = color2;
        document.getElementById(StructureType + "-239").style.background = color3;
      }
      if (ParamID == 110) {
        document.getElementById(StructureType + "-110").style.background = color1;
        document.getElementById(StructureType + "-99").style.background = color2;
        document.getElementById(StructureType + "-239").style.background = color3;
      }

      if (ParamID == 45) {
        document.getElementById(StructureType + "-45").style.background = color1;
        document.getElementById(StructureType + "-246").style.background = color2;
        document.getElementById(StructureType + "-181").style.background = color3;
      }

      if (ParamID == 226) {
        document.getElementById(StructureType + "-280").style.background = color1;
        document.getElementById(StructureType + "-226").style.background = color2;
        document.getElementById(StructureType + "-248").style.background = color3;
      }
      if (ParamID == 3256) {
        document.getElementById(StructureType + "-3256").style.background = color1;
        document.getElementById(StructureType + "-336").style.background = color2;
        if (StructureType == "Apartment") { document.getElementById(StructureType + "-369").style.background = color3; }
        else { document.getElementById(StructureType + "-3258").style.background = color3; }


      }
      if (ParamID == 256) {
        document.getElementById(StructureType + "-256").style.background = color1;
        document.getElementById(StructureType + "-36").style.background = color2;
        if (StructureType == "Apartment") { document.getElementById(StructureType + "-69").style.background = color3; }
        else { document.getElementById(StructureType + "-258").style.background = color3; }


      }
      if (ParamID == 41) {
        document.getElementById(StructureType + "-41").style.background = color1;
        document.getElementById(StructureType + "-259").style.background = color2;
        document.getElementById(StructureType + "-255").style.background = color3;
      }

      if (ParamID == 43) {
        document.getElementById(StructureType + "-278").style.background = color1;
        document.getElementById(StructureType + "-43").style.background = color2;
        document.getElementById(StructureType + "-260").style.background = color3;
      }
      if (ParamID == 44) {
        document.getElementById(StructureType + "-279").style.background = color1;
        document.getElementById(StructureType + "-44").style.background = color2;
        document.getElementById(StructureType + "-261").style.background = color3;
      }
      if (ParamID == 42) {
        document.getElementById(StructureType + "-42").style.background = color2;
        document.getElementById(StructureType + "-262").style.background = color3;
      }
    }
    //Setinfostyle("form-control");
  }
  // const setObject = async (image, active, item) => {
  //   // object[name].find((item) => item.image_type == image.image_type);
  //   let uploadedImage = await amazonUpload(image);
  //   let tabsimages = tabsImage;
  //   let newArr = tabsImage[active].map((item2) =>
  //     item2.image_type === item.image_type
  //       ? {
  //           ...item2,
  //           image_url: uploadedImage.location,
  //           image_name: uploadedImage.key,
  //         }
  //       : item2
  //   );
  //   tabsimages[active] = newArr;
  //   setTabsImage(tabsimages);
  //   setImages(newArr);
  // };
  // let isComplete=0;
  // {object &&
  //   object[name].slice(0, 1).map((item) => isComplete=item.isComplete)}

  if (name != null) {
    return (


      <div class="card-header" >
        <h5 class="mb-0">
          <button type="button"
            class="btn btn-link  w-100 d-flex justify-content-between align-items-center collapsed"
            data-toggle="collapse"
            data-target={`#collapse${index}`}
            aria-expanded="true"
            aria-controls={`collapse${index}`} onClick={() => Iscollapse(index + active)} >

            <div class="left">
              <span class="rotate-arrow">
                <i class="fa fa-caret-down" id={index + active}></i>

                {/* <img class="down" src="/assets/img/angle-down.png" alt="" id={index+active} ></img> */}
              </span>
              <span> {name === "StructureImages" ? "Structure Images" : name}</span>
            </div>

            {/* <div class="right" >
              
              {isComplete==0?(  <span class="com-not">Not Complete</span>):( <span class="com-not complete">Complete</span>)}
              
             
            
              </div> */}
          </button>
        </h5>


        {/* <div class="card-header" id="headingOne">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-left"
            type="button"
            data-toggle="collapse"
            data-target={`#collapse${index}`}
            aria-expanded="true"
            aria-controls={`collapse${index}`}
          >
           
          </button>
        </h2>
      </div> */}

        {name !== "StructureImages" ? (
          <div
            id={`collapse${index}`}
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >

            {(name == "Building Cost Breakdown") ? (

              <div class="row justify-content-end">

                <div class="col-xl-8 col-lg-8 mt-3">
                  <div class="table-outer mt-2">


                    <div class="row mytable " style={{ width: "100%" }}>
                      {list && object &&
                        object[name] && list.map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} onDragStart={onDragStart} onDragOver={onDragOver} onDrop={onDrop} onDragLeave={onDragLeave} />)}

                      {/* {object &&
                    object[name].map((item) => Components(item, object[name], setObject2, useVals,0,object,""))} */}

                    </div>



                  </div>
                </div>

                <div class="col-xl-3 col-lg-4 text-center desktopinfo" style={{ marginTop: "7%" }}>
                  <div class={IsDisplay} id={name + active} name="InfoBox" style={{ display: "none" }}>
                    <div class="cross" id="desktopClose" onClick={() => closeInfo(name + active)} >

                    </div>
                    <h6 class="text-left" id={"H" + name + active}>

                    </h6>
                    <p class="text-left" id={"I" + name + active}>

                    </p>

                  </div>

                </div>
              </div>
            ) : (
              (name == "Sales Cost Breakdown" || name == "Proforma Breakdown" || name == "Land Analysis") ? (

                <div class="row justify-content-end">
                  <div class="col-xl-8 col-lg-8 mt-3">
                    <div class="table-outer mt-2">


                      <div class="row mytable ">
                        {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} />

                        )}

                        {/* {object &&
                    object[name].map((item) => Components(item, object[name], setObject2, useVals,0,object,""))} */}

                      </div>



                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-4 text-center desktopinfo" style={{ marginTop: "7%" }}>
                    <div class={IsDisplay} id={name + active} name="InfoBox" style={{ display: "none" }}>
                      <div class="cross" onClick={() => closeInfo(name + active)} >

                      </div>
                      <h6 class="text-left" id={"H" + name + active}>

                      </h6>
                      <p class="text-left" id={"I" + name + active}>

                      </p>

                    </div>

                  </div>
                </div>
              ) : (
                <div class="row justify-content-end">
                  {name == "Site Potential" ? (
                    <>
                      { }
                      <div class="col-xl-8 col-lg-8">
                        <form class="row input-box ">
                          {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} />)}

                          {/* {object && object[name].map((item) => Components(item, object[name], setObject2, useVals,0,object,""))} */}
                        </form>
                        <div class=" table-outer mt-2">
                          <div class="row mytable " style={{ width: "107%" }}>
                            {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={1} object={object} />)}

                            {/* {object && object[name].map((item) => Components(item, object[name], setObject2, useVals,1,object,""))} */}
                          </div>
                        </div>
                      </div>



                      <div class="col-xl-3 col-lg-4 text-center desktopinfo" >
                        <div class={IsDisplay} id={name + active} name="InfoBox" style={{ display: "none" }}>
                          <div class="cross" onClick={() => closeInfo(name + active)} >

                          </div>
                          <h6 class="text-left" id={"H" + name + active}>

                          </h6>
                          <p class="text-left" id={"I" + name + active}>

                          </p>

                        </div>

                      </div>
                    </>) :
                    (<> <div class="col-xl-9 col-lg-8"> <form class="input-box1 ">
                      <div class="row financingdiv " id="loan">
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,0,object,""))} */}
                        {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={0} object={object} />)}

                      </div>
                      <div class="row financingdiv " id="cons">
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,1,object,""))} */}
                        {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={1} object={object} />)}

                      </div>
                      <div class="row financingdiv " id="ext">
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,2,object,""))} */}
                        {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={2} object={object} />)}

                      </div>
                      <div class="row " style={{ width: "100%" }}>
                        {/* {object &&
  object[name].map((item) => Components(item, object[name], setObject2, useVals,3,object,""))} */}
                        {list && object && object[name].map((item) => <Components item={item} data={object[name]} setData={setObject2} useVals={useVals} IsSite={3} object={object} />)}

                      </div>
                    </form> </div> <div class="col-xl-2 col-lg-2 text-center " >


                      </div></>)}

                </div>
              )
            )
            }

          </div>

        ) : (
          // <div style={{ margin: "3%" }} class="row">
          //   {images &&
          //     images.map((item) => (
          //       <div class="col-md-4">
          //         <div class="profile-pic-change d-flex">
          //           <img
          //             src={item.image_url}
          //             alt="User Image"
          //             class="user-avatar"
          //             id={`${
          //               item.image_type + item.structure_type_id + item.image_url
          //             }`}
          //             key={`${
          //               item.image_type + item.structure_type_id + item.image_url
          //             }`}
          //           ></img>
          //           <div class="form-group">
          //             <label class="ml-3">{item.image_type}</label>

          //            </div>
          //           {/* <i class="far fa-trash-alt icon-del"></i> */}
          //         </div> 
          //       </div>
          //     ))}
          // </div>
          <></>
        )}
      </div>
    );
  }
  {
    return (null);
  }
}

export default TabComponent;
